

<div class="linkGraphicsSection">
  <div class="gif"></div>

  <div class="experienceSection">
    <div class="linkGraphic box1">
    <div class="graphicTitle">
      <h3>53</h3>
      <p>Years of Service</p>
    </div>
  </div>

  <div class="linkGraphic box2">
    <div class="graphicTitle">
      <h3>48</h3>
      <p>Branch Locations</p>
    </div>
  </div>

  <div class="linkGraphic box3">
    <div class="graphicTitle">
      <h3>50M</h3>
      <p>Patrons Served Annually</p>
    </div>
  </div>

  <div class="linkGraphic box4">
    <div class="graphicTitle">
      <h3>60K</h3>
      <p>Team Members</p>
    </div>
  </div>
  </div>


</div>
